<template>
  <div class="g-top">
    <div class="g-top-content">
      <span class="top-login" @click="show=true;" v-if="!user">
        你好，请登录
      </span>
      <span class="top-reg" @click="$router.push('/login/register')" v-if="!user">
        免费注册
      </span>
      <Dropdown trigger="hover" v-if="user">
        <span style="line-height: 30px;cursor:pointer;">{{user.name || "匿名用户"}}</span>
        <DropdownMenu slot="list" style="width:100px; text-align: center;">
          <DropdownItem @click.native="modelShow=true">我的信息</DropdownItem>
          <DropdownItem @click.native="collectOpen=true">关注企业</DropdownItem>
          <DropdownItem @click.native="procollectOpen=true">关注产品</DropdownItem>
          <DropdownItem @click.native="chancecollectOpen=true">关注供需</DropdownItem>
          <DropdownItem @click.native="linkToEx">展商登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <span v-if="user" style="line-height: 30px;cursor:pointer;" @click="isExit=true;"> ， 退出</span>
      <span class="line">|</span>
      <span class="top-cn">中</span>
      <span class="line">|</span>
      <span class="top-en" @click="goEn">En</span>
    </div>

    <gLogin :show="show" @close="show=false;" />
    <editInfo :show="modelShow" :modelTitle="modelTitle" @close="modelShow = false" @finsh="finsh"></editInfo>
    <myCollect :show="collectOpen" @close="collectOpen=false"></myCollect>
    <proCollect :show="procollectOpen" @close="procollectOpen=false"></proCollect>
    <chanceCollect :show="chancecollectOpen" @close="chancecollectOpen=false"></chanceCollect>
    <iModal cancel-text title="" width="416" v-model="isExit" :closable="false" :footer-hide="true">
      <div class="exit-modal">
        <div class="exit-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>确认</p>
        </div>
        <div class="exit-modal-bottom">
          <p>是否退出 ？</p>
        </div>
        <div class="exit-modal-btn">
          <Button type="text" @click="isExit=false;">取消</Button>
          <Button type="primary" @click="confirm()" style="margin-left:10px;">确定</Button>
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import config from "@assets/config.json";
import gLogin from "@components/gLogin/gLogin.vue";
import editInfo from "../modal/edit-info";
import myCollect from "../modal/my-collect";
import proCollect from "../modal/pro-collect";
import chanceCollect from "../modal/chance-collect";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "g-top",
  data() {
    return {
      show: false,
      modelShow: false,
      collectOpen:false,
      procollectOpen:false,
      chancecollectOpen:false,
      modelTitle: "我的信息",
      isExit: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    })
  },
  created() {
    // console.log("用户信息：",this.user);
  },
  methods: {
    ...mapActions({
      exit: "loginModule/exit"
    }),
    finsh() {},
    linkToEx() {
      window.open(`${config.BackendUrl}/exhibition/login/alogin`);
    },
    goEn() {
      let url = location.origin + "/homeEn";
      window.open(url, "_blank");
    },
    confirm() {
      this.isExit=false;
      setTimeout(() => {
        this.exit();
      },100)
    }
  },
  components: {
    gLogin,
    editInfo,
    myCollect,
    proCollect,
    chanceCollect
  }
};
</script>

<style lang="scss" scoped>
.g-top {
  width: 100%;
  height: 30px;
  background-color: #f5f5f5;
  &-content {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    font-size: 12px;
  }
  .top-login {
    cursor: pointer;
    line-height: 30px;
  }
  .top-reg {
    color: #e60012;
    margin-left: 5px;
    cursor: pointer;
  }
  .line {
    color: #e6e6e6;
    font-size: 14px;
    margin: 0 10px;
  }
  .top-cn {
    display: inline-block;
    width: 30px;
    height: 17px;
    background-color: #024c8b;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
  .top-en {
    cursor: pointer;
  }
}
.exit-modal {
  padding: 6px 16px 8px;
  &-top {
    display: flex;
    align-items: center;
    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }
  &-bottom {
    margin-left: 40px;
  }
  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}
</style>